import { render } from "./AppInputTime.vue?vue&type=template&id=16513320&scoped=true&ts=true"
import script from "./AppInputTime.vue?vue&type=script&lang=ts"
export * from "./AppInputTime.vue?vue&type=script&lang=ts"

import "./AppInputTime.vue?vue&type=style&index=0&id=16513320&lang=postcss&scoped=true"

import exportComponent from "/builds/wVusKqw4/1/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16513320"]])

export default __exports__